
import React from 'react';
import { Card } from '@/components/ui/card';
import { Clock, Book, Save } from 'lucide-react';

interface EditorWordStatsProps {
  wordCount: number;
  readingTime: number;
  lastSavedTime: Date | null;
}

const EditorWordStats: React.FC<EditorWordStatsProps> = ({ 
  wordCount, 
  readingTime, 
  lastSavedTime 
}) => {
  return (
    <Card className="flex justify-between items-center text-sm text-muted-foreground max-w-[700px] mx-auto px-4 py-2 border-border/40 shadow-sm bg-card/60 backdrop-blur-sm">
      <div className="flex gap-4">
        <div className="flex items-center">
          <Book className="h-4 w-4 mr-1.5 text-primary/70" />
          <span>{wordCount.toLocaleString()} words</span>
        </div>
        
        <div className="flex items-center">
          <Clock className="h-4 w-4 mr-1.5 text-primary/70" />
          <span>~{readingTime} min read</span>
        </div>
      </div>
      
      {lastSavedTime && (
        <div className="flex items-center">
          <Save className="h-4 w-4 mr-1.5 text-primary/70" />
          <span>
            Last saved: {lastSavedTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </span>
        </div>
      )}
    </Card>
  );
};

export default EditorWordStats;
